<template>
  <div class="container">
    <h4 class="title is-4">Preference: {{ preference.name }}</h4>
    <h6 class="title is-6">
      Rename Preference
    </h6>
    <div class="field has-addons">
      <div class="control is-expanded">
        <input class="input" v-model="updatedName" @keyup.enter="updatePreference()" />
      </div>
      <div class="control">
        <button class="button" @click="updatePreference()" @keyup.enter="updatePreference()">
          Update Preference
        </button>
      </div>
    </div>
    <h6 class="title is-6">
      Delete Preference
    </h6>

    <div class="field">
      <button class="button is-primary" @click="deletePreference">Delete Preference</button>
    </div>
    <p>Be sure you want to do this! This preference will not be able to be recovered!</p>
  </div>
</template>

<script>
import Preference from '@/services/preferences/'

export default {
  data() {
    return {
      updatedName: '',
      preference: {},
      preferenceId: null,
    }
  },
  created() {
    this.preferenceId = this.$route.params.preferenceId
    this.refreshData()
  },
  methods: {
    updatePreference() {
      const fields = ['name']
      let updatedPreference = Preference.create(this.preference)
      updatedPreference.name = this.updatedName
      Preference.api.update(updatedPreference, fields).then(() => {
        this.$Alert.alert({
          type: 'success',
          message: `<p>Tag updated!</p>`,
          timeout: 6000,
        })
        this.$router.push({ name: 'StaffEditPreferences' })
      })
    },
    deletePreference(preference) {
      Preference.api.delete(preference.id).then(() => {
        this.$Alert.alert({
          type: 'success',
          message: `<p>Tag deleted!</p>`,
          timeout: 6000,
        })
        this.$router.push({ name: 'StaffEditPreferences' })
      })
    },
    refreshData() {
      Preference.api.get(this.preferenceId).then(data => {
        this.preference = data
        this.updatedName = this.preference.name
      })
    },
  },
}
</script>

<style scoped></style>
